import { render, staticRenderFns } from "./ContentLatest.vue?vue&type=template&id=5f73bd21"
import script from "./ContentLatest.vue?vue&type=script&lang=ts"
export * from "./ContentLatest.vue?vue&type=script&lang=ts"
import style0 from "./ContentLatest.vue?vue&type=style&index=0&id=5f73bd21&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports